module.exports = __webpack_public_path__ + "img/puzzle3.jpg";